import { IImageCategory } from 'api/types/_image';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { deleteImageCategory, getAllImageCategory, getImageCategories as onGetImageCategories } from "../../../store/thunks";
import GoogleForm from './GoogleForm';
import SiteForm from './SiteForm';
import DropdownOption from 'components/Common/DropdownOption';
import { Option } from 'api/types/_public';
import DropdownCategory from 'components/Common/DropdownCategory';
export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);


const GoogleImage = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const DEPTH_OPTIONS_LANG: Option[] = [{ label: '1', value: '1' }, { label: '2', value: '2' }];

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    // date: withDefault(StringParam, moment().format("Y-MM-DD")),
    name: withDefault(StringParam, ''),
    site: withDefault(StringParam, ''),
    category_id: withDefault(StringParam, ''),
    // depth: withDefault(StringParam, ''),
  });

  const [idLoading, setIdLoading] = useState<string | number | null>(null);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] = useState<IImageCategory | null>(null);

  const [nameSearch, setNameSearch] = useState<string>(query?.name || "");

  const [siteSearch, setSiteSearch] = useState<string>(query?.site || "");

  const [depthSearch, setDepthSearch] = useState<Option | null>(DEPTH_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.depth)) || null);

  const [dateSearch, setDateSearch] = useState<any>(query?.date ? moment(query?.date, 'Y-MM-DD').toDate() : null);

  const [imageCategoryEdit, setImageCategoryEdit] = useState<IImageCategory & { isCopy?: boolean } | null>(null);

  const [addImageCategory, setAddImageCategory] = useState<IImageCategory & { isCopy?: boolean } | null>(null);

  const [optionImageCategories, setOptionImageCategories] = useState<any>([]);

  const [categorySearch, setCategorySearch] = useState<any>(query?.category_id ? { value: query?.category_id, label: '' } : null);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Image;

  const ImageProperties = createSelector(
    selectLayoutState,
    (state) => ({
      imageCategories: state.imageCategories,
      isImageCategorySuccess: state.isImageCategorySuccess,
      isImageCategoryLoading: state.isImageCategoryLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { imageCategories, error, isImageCategoryLoading } = useSelector(ImageProperties);

  useEffect(() => {
    dispatch(onGetImageCategories(query));
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    const queryNew = {
      ...query,
      name: nameSearch || '',
      site: siteSearch || '',
      depth: depthSearch?.value || '',
      category_id: categorySearch?.value || '',
      date: dateSearch ? moment(new Date(dateSearch)).format("Y-MM-DD") : '',
      page: 1,
      time_request: + new Date()
    };
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      ...query,
      name: '',
      site: '',
      depth: '',
      category_id: '',
      order_by: 'DESC',
      sort_by: TYPE_SELECT_DEFAULT,
      date: `${moment().format("Y-MM-DD")}`,
      time_request: + new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setNameSearch((_prev) => "");
    setSiteSearch((_prev) => "");
    setDepthSearch((_prev) => null);
    setCategorySearch((_prev: any) => null);
    setDateSearch(moment(queryNew?.date || "", 'Y-MM-DD').toDate());
  };
  // 

  const onCloseClick = () => {
    setImageCategoryEdit((_prev) => null);
    setIsOpen((_prev) => false);
  }

  const onCloseAddImageCategoryClick = () => {
    setAddImageCategory((_prev) => null);
  }

  const handleRefreshOptionImageCategories = async () => {
    try {
      const [res1]: any = await Promise.all([getAllImageCategory({})]);;
      setOptionImageCategories((_prev: any) => (res1?.data || []));
    } catch (error: any) {
      return error;
    }
  }

  const triggerRefresh = (is_refresh_categories: boolean = false) => {
    onCloseClick();
    onCloseAddImageCategoryClick();
    handleRefreshOptionImageCategories();
    setQuery({
      ...query,
      time_request: + new Date(),
    });
  }
  //End::Update User

  // Begin::Delete
  const handleConfirmDelete = (item: IImageCategory | null) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!initialValuesDefault?.id) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await deleteImageCategory(initialValuesDefault?.id);
      if (response?.code === 200) {
        triggerRefresh();
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete


  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-center',
        thWidth: 90,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div className="text-center pe-3" style={{ minWidth: '60px' }}>{((query?.page - 1) * (query?.limit)) + (cell?.cell?.row?.index + 1)}</div>
            </>
          )
        },
      },
      {
        Header: t('Level') + ' 1',
        accessor: "depth",
        filterable: true,
        sortable: false,
        width: 150,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '130px' }} className="d-flex align-items-center">
              {Number(cell?.value) === 1 ? (item?.name || '') : (item?.groups?.[0]?.name || '')}
              {Number(cell?.value) === 1 &&
                <TooltipCustom
                  title={t("Add Category Level 2")}
                  className="d-inline-block vertical-align-middle"
                >
                  <span className="align-middle px-2 fs-20 text-primary cursor-pointer" onClick={(e) => { e.preventDefault(); setAddImageCategory((prev) => item) }}>
                    <i className="ri-add-fill align-text-top" />
                  </span>
                </TooltipCustom>
              }
            </div>
          </>)
        },
      },
      {
        Header: t('Level') + ' 2',
        accessor: "name",
        filterable: true,
        sortable: false,
        width: 150,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '130px' }}>
              {Number(item?.depth) === 2 ? (item?.name || '') : '-'}
            </div>
          </>)
        },
      },
      {
        Header: t('Site'),
        accessor: "sites",
        filterable: true,
        sortable: false,
        thClass: 'text-start align-middle',
        width: 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="pe-3 text-start" style={{ minWidth: '130px' }}>
              {(cell?.value || [])?.length ? (cell?.value || [])?.map((site: any, index: number) => (
                <div className="mb-1" key={index}>
                  <a className="text-primary" target="_blank" href={site?.url || ''}>
                    {site?.url || ''}
                  </a>
                </div>
              )) : <>-</>}
            </div>
          </>)
        },
      },
      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 130,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '120px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated at'),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: 'text-end align-middle',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Action'),
        thWidth: 100,
        thClass: 'text-center align-middle',
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '70px' }}>
              {isHavePermissionRole(ROLES_FOR_APP.GOOGLE_IMAGE_UPDATE, userPermissions) && <TooltipCustom
                title={t('Button Update Image Category')}
                id={`update-us-${item?.id}`}
              >
                <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
                  <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                    onClick={(e) => { e.preventDefault(); setImageCategoryEdit((prev) => item) }}
                  >
                    <i className="ri-pencil-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>}
              {isHavePermissionRole(ROLES_FOR_APP.GOOGLE_IMAGE_DELETE, userPermissions) && (
                <TooltipCustom
                  title={t('Button Delete Image Category')}
                  id={`detail-cp-${item?.id}`}
                >
                  <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                    <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                      onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                    >
                      <i className="ri-delete-bin-3-fill align-bottom"></i>
                    </Link>
                  </li>
                </TooltipCustom>
              )}
            </ul>
          );
        },
      },
    ],
    [i18n?.language, query, userPermissions]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy });
    });
  }, []);

  const handleChangeDatePicker = (date: any) => {
    setDateSearch((_prev: any) => date);
  }

  const handleCallAllOption = async () => {
    try {
      handleRefreshOptionImageCategories();
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Image Management')} - ${t('Google Image')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Google Image')} pageTitle={t('Image Management')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.GOOGLE_IMAGE_LIST, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-7">
                        <div>
                          <h5 className="card-title mb-0">
                            <span>
                              <span className="me-2">{t('Total')}:</span>
                              <CountUp
                                start={0}
                                end={imageCategories?.pagination?.total || 0}
                                duration={1}
                                className="text-primary"
                              />
                            </span>
                          </h5>
                        </div>
                      </div>
                      <div className="col-5 text-end">
                        {isHavePermissionRole(ROLES_FOR_APP.GOOGLE_IMAGE_CREATE, userPermissions) && (<div className="col-sm-auto">
                          <div>
                            <button
                              type="button"
                              className="btn btn-success add-btn rounded-pill"
                              id="create-btn"
                              onClick={() => setIsOpen((_prev) => true)}
                            >
                              <i className="ri-add-line align-bottom me-1"></i>
                              {t('Button Create Image Category')}
                            </button>
                          </div>
                        </div>)}
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <Row className="g-4 align-items-center mt-0">
                      <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Name')} isShow={!!nameSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t('Name')}...`}
                            value={nameSearch}
                            onChange={(e) => setNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Site')} isShow={!!siteSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t('Site')}...`}
                            value={siteSearch}
                            onChange={(e) => setSiteSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Category')} isShow={true}>
                          <DropdownCategory
                            name="category"
                            placeholder={t('Category')}
                            isClearable={true}
                            dataList={optionImageCategories}
                            initialValue={categorySearch ?? null}
                            onChangeCategory={(event) => {
                              setCategorySearch(event)
                            }}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                          />
                        </LabelWrapper>
                      </Col>
                      <Col sm={6} md={6} lg={6} xl={12} xxl={3} className="order-1 order-md-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-xxl-start mt-3 mt-xxl-2">
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-2 "
                            onClick={searchData}
                            disabled={isImageCategoryLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t('Button Search')}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t('Button Reset')}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-3">
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle"
                      theadClass="table-light"
                      columns={columns}
                      data={imageCategories?.list?.length ? imageCategories?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={imageCategories?.pagination?.total}
                      customPageCount={Math.ceil(Number(imageCategories?.pagination?.total) / Number(imageCategories?.pagination?.limit))}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isImageCategoryLoading}
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={!!imageCategoryEdit?.id || isOpen}
          centered={true}
          size="md"
          scrollable={true}
        >
          <ModalHeader toggle={onCloseClick}>
            <>{!!(imageCategoryEdit?.id) ? t("Button Update Image Category") : t("Button Create Image Category")}</>
            {/* <>{(imageCategoryEdit?.id) && (<> - {(imageCategoryEdit?.name || '')}</>)}</> */}
          </ModalHeader>
          <ModalBody className="pt-2">
            <div>
              <GoogleForm
                isModal={true}
                isShowLevel1Dropdown={!!imageCategoryEdit?.id}
                id={String(imageCategoryEdit?.id || '')}
                isCopy={!!(imageCategoryEdit?.isCopy)}
                triggerRefresh={triggerRefresh}
                categories={(optionImageCategories || [])?.map((cate: any) => ({ label: cate?.name, value: String(cate?.id) }))}
              />
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={!!addImageCategory?.id}
          centered={true}
          size="md"
          scrollable={true}
        >
          <ModalHeader toggle={onCloseAddImageCategoryClick}>
            <>{t("Add Category Level 2")}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <div>
              <SiteForm
                isModal={true}
                id={String(addImageCategory?.id || '')}
                isCopy={!!(addImageCategory?.isCopy)}
                triggerRefresh={triggerRefresh}
              />
            </div>
          </ModalBody>
        </Modal>

        <ModalConfirm
          header={t('Button Delete Image Category')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default GoogleImage;